jQuery(document).ready(function($) {
  
    if(document.querySelector('.checkout-page')) {
      jQuery(function($) {
        // If there is only one shipping method, automatically select it
        if ($('.shipping_method').length === 1) {
            $('.shipping_method').prop('checked', true).trigger('change');
        }
    });
    
  // Update the quantity on plus click
  $('.checkout-plus').on('click', function() {
    var $quantity = $(this).siblings('.checkout-current-quantity').find('#checkout-quantity');
    var currentQuantity = parseInt($quantity.text());
    var cartItemKey = $(this).data('cart_item_key');
    
    // Increase the quantity
    var newQuantity = currentQuantity + 1;
    updateCartItemQuantity(cartItemKey, newQuantity, $quantity);
  });

  // Update the quantity on minus click
  $('.checkout-minus').on('click', function() {
    var $quantity = $(this).siblings('.checkout-current-quantity').find('#checkout-quantity');
    var currentQuantity = parseInt($quantity.text());
    var cartItemKey = $(this).data('cart_item_key');
    
    // Prevent quantity from going below 1
    if (currentQuantity > 1) {
      var newQuantity = currentQuantity - 1;
      updateCartItemQuantity(cartItemKey, newQuantity, $quantity);
    }
  });

  // Remove item from the cart
  $('.checkout__remove .remove_from_cart_button').on('click', function(e) {
    e.preventDefault();
    var cartItemKey = $(this).data('cart_item_key');
    
    // Send AJAX request to remove item
    $.ajax({
      type: 'POST',
      url: woocommerce_params.ajax_url,
      data: {
        action: 'remove_from_cart',
        cart_item_key: cartItemKey
      },
      success: function(response) {
        // Update the cart dynamically
        updateCart();
      }
    });
  });

  // Function to update cart item quantity via AJAX
  function updateCartItemQuantity(cartItemKey, newQuantity, $quantityElement) {
    $.ajax({
      type: 'POST',
      url: woocommerce_params.ajax_url,
      data: {
        action: 'update_cart_item',
        cart_item_key: cartItemKey,
        quantity: newQuantity
      },
      success: function(response) {
        // Update the quantity displayed
        $quantityElement.text(newQuantity);
        // Dynamically update the cart
        updateCart();
      }
    });
  }

  // Function to update the cart content and total dynamically
  function updateCart() {
    $.ajax({
      type: 'POST',
      url: woocommerce_params.ajax_url,
      data: {
        action: 'update_cart'
      },
      success: function(response) {
        // WooCommerce's cart fragment system should update the necessary elements.
        // Here we update the entire cart content, including the footer (total).
        $(document.body).trigger('updated_cart_totals'); // Trigger the WooCommerce cart fragment update

        // Manually updating cart footer
        $('.checkout-page__footer').html($(response).find('.checkout-page__footer').html());
      }
    });
  }

}
  });
  